import { useToast as useToastContext } from "@/components/ui/toast"
import * as React from "react"

// Adapter: expose `toast` function compatible with shadcn/ui useToast API
export function useToast() {
  const { addToast } = useToastContext()

  const toast = React.useCallback(({
    title,
    description,
    variant,
  }: {
    title: string
    description?: string
    variant?: "default" | "success" | "error" | "warning" | "destructive"
  }) => {
    // map shadcn "destructive" variant to our "error"
    const mappedVariant =
      variant === "destructive" ? "error" : (variant as "default" | "success" | "error" | "warning" | undefined)
    addToast({ title, description, variant: mappedVariant })
  }, [addToast])

  return { toast }
}
